import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {

  constructor(private http: HttpClient) { }

  getPdfLicense(licenseId: number) {
    return this.http.get(`Document/GetLicensePdf?licenseId=${licenseId}`);
  }

  getRecentActivities(mdmid: string) {
    return this.http.get<any[]>(`Dashboard/ActivitiesByUser?rutDv=${mdmid}`).pipe(map((arr) => {
      if (arr.length > 5) {
        return arr.splice(0, 5);
      }
      return arr;
    }));
  }

  getRecentRequirements(mdmid: string) {
    return this.http.get<any[]>(`Dashboard/RequirementsByUser?rutDv=${mdmid}`).pipe(map((arr) => {
      if (arr.length > 5) {
        return arr.splice(0, 5);
      }
      return arr;
    }));
  }
}

export interface User {
  id: number;
  fullName: string;
  entity: string;
  management: string;
  shiftWork: string;
  company: string;
  rutDv: string;
  businessUnit: string;
  email: string;
  photo: string;
  area: string;
  role: string;
}
